import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import * as amplitude from '@amplitude/analytics-browser';
import { environment } from '@env/environment';
import { RecognizingFaceEventData, WEB_ASSISTANT_ID } from '@analytics/recognizing-face-events';

@Injectable({
  providedIn: 'root'
})
export class AmplitudeService {
  private isBrowser: boolean;
  private platformId = inject(PLATFORM_ID);
  constructor() {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  init(): void {
    if (!this.isBrowser || !environment.amplitude.apiKey) {
      return;
    }

    try {
      amplitude.init(environment.amplitude.apiKey, WEB_ASSISTANT_ID, {
        autocapture: false // Desactivar autocapture que captura clicks y otros eventos automáticamente
      });
    } catch (error) {
      console.error(error);
    }
  }
   
  logEvent(eventName: string, eventProperties?: RecognizingFaceEventData): void {
    if (!this.isBrowser) return;
    try {
      amplitude.logEvent(eventName, eventProperties);
    } catch (error) {
      console.error(`Amplitude Service: Error al registrar evento ${eventName}.`, error);
    }
  }

  setUserId(userId: string | undefined): void {
    if (!this.isBrowser) return;
    amplitude.setUserId(userId);
  }

  getUserId(): string | undefined {
    if (!this.isBrowser) return undefined;
    try {
      const userId = amplitude.getUserId();
      return userId || undefined;
    } catch (error) {
      console.error('Amplitude Service: Error al obtener user ID.', error);
      return undefined;
    }
  }

  setUserProperties(userProperties: amplitude.Types.IIdentify): void {
    if (!this.isBrowser) return;
    amplitude.identify(userProperties);
  }

  reset(): void {
    if (!this.isBrowser) return;
    amplitude.reset();
  }
}